import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import { CallRecording } from '@adornis/voice-assistant/call-recordings.js';
import { map } from 'rxjs';

export type RecordingPlayback = { state: 'available' | 'expired' | 'unavailable' | 'missing'; url: string | null };

/** Tombstones stay in call-recordings so recording-only legacy calls remain in the overview. */
export function recordingPlayback(recording: any): RecordingPlayback {
  if (!recording) return { state: 'missing', url: null };
  if (recording.audioExpiredAt || recording.audioRetentionState === 'expired') return { state: 'expired', url: null };
  if (recording.audioRetentionState === 'deleting') return { state: 'unavailable', url: null };
  return { state: 'available', url: CallRecording.makeLink('serve', recording._id) };
}

export function parseRecordingPlayback(value: unknown): RecordingPlayback {
  try {
    const parsed = JSON.parse(String(value ?? ''));
    if (['available', 'expired', 'unavailable', 'missing'].includes(parsed.state)) return parsed;
  } catch {}
  return { state: 'missing', url: null };
}

// startup imports this module before installing the shared authenticated-operation middleware.
export const subscribeRecordingPlayback = registerSubscription({
  operationName: 'subscribeRecordingPlayback',
  params: [{ name: 'callID', type: () => String }],
  type: () => String,
  resolve: (callID: string) => () =>
    watchQuery(CallRecording._collectionName, { callID }, { sort: { createdAt: -1, _id: -1 }, limit: 1 }).pipe(
      map(rows => JSON.stringify(recordingPlayback(rows[0]))),
    ),
});
